import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import { createInquiryLineCardFormService, InquiryLineCardFormModel, InquiryLineCardFormParamter } from "@tCentro/Services/CENInquiryLineCardService";

type HandlerType = ApiHandler<
InquiryLineCardFormParamter & HasOnSuccess<InquiryLineCardFormModel>,
InquiryLineCardFormModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await createInquiryLineCardFormService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const createInquiryLineCardForm = createHandlerChainRunner(chain, "createInquiryLineCardForm");
export default createInquiryLineCardForm;
